export default "__VITE_ASSET__CzmeEf9M__"